import { Component } from "@angular/core";
import { Toast } from "ngx-toastr";

@Component({
  selector: "[lib-custom-toast]",
  templateUrl: "./custom-toast.component.html",
  styleUrls: ["./custom-toast.component.scss"],
  preserveWhitespaces: false,
  standalone: false,
})
export class CustomToastComponent extends Toast {
  action(event: Event) {
    event.stopPropagation();
    this.toastPackage.triggerAction();
    return false;
  }
}
